export default [
    {
        id: 0,
        name: 'Empty',
        type: [
            'I',
            'V',
        ],
    },
    {
        id: 1,
        name: 'Aerodrive',
        description: 'Ignore terrain when moving and checking line of sight both for and against you. Ignore collisions and brawl attacks. Your Motion is 3.',
        type: [
            'V',
        ],
    },
    {
        id: 2,
        name: 'Amplifier',
        description: 'Before each attack, you may increase the power of the weapon being fired by 1, ignoring the normal limits.',
        type: [
            'M',
        ],
    },
    {
        id: 3,
        name: 'Armour',
        description: 'Roll 5+ to ignore each hit. If this unit has two Armour modules, roll 3+ instead.',
        type: [
            'I',
            'V',
        ],
    },
    {
        id: 4,
        name: 'Booster',
        description: 'Once per attack turn, gain Heat equal to class to rotate then move up to 3".',
        type: [
            'A',
        ],
    },
    {
        id: 5,
        name: 'Carrier',
        description: 'Keep up to two infantry AUs off the board, noted as being inside this carrier. On their move activation they may deploy from their carrier unit. If the carrier is destroyed, all AUs inside are also destroyed. Deployed units cannot re-enter the carrier.',
        type: [
            'M',
            'V',
        ],
    },
    {
        id: 6,
        name: 'Casing',
        description: 'When you would take internal damage, hit this module instead.',
        type: [
            'M',
        ],
    },
    {
        id: 7,
        name: 'Catalyst',
        description: 'Your first attack each turn generates 1 less Heat.',
        type: [
            'M',
        ],
    },
    {
        id: 8,
        name: 'Cloak',
        description: 'When you hold as your move, you may set Motion to 6. AUs can do this.',
        type: [
            'A',
        ],
    },
    {
        id: 9,
        name: 'Conductor',
        description: 'At the end of your move turn, you may cause 1 Heat to a visible MAC within 3".',
        type: [
            'A',
        ],
    },
    {
        id: 10,
        name: 'Coolant',
        description: 'Lose 2 Heat in cooldown. When this module is destroyed gain 2 Heat.',
        type: [
            'M',
        ],
    },
    {
        id: 11,
        name: 'Disruptor',
        description: 'At the end of your move turn, you may force a visible MAC within 3" of you to pass a system check or crash.',
        type: [
            'A',
        ],
    },
    {
        id: 12,
        name: 'Dozer',
        description: 'Count as 2 classes larger for collisions you cause.',
        type: [
            'V',
        ],
    },
    {
        id: 13,
        name: 'ECM',
        description: 'At the end of your attack turn, increase your Motion by 1.',
        type: [
            'M',
        ],
    },
    {
        id: 14,
        name: 'Emitter',
        description: 'At the end of your move turn, you may cause 1 Rad to a visible MAC within 3".',
        type: [
            'A',
        ],
    },
    {
        id: 15,
        name: 'Frame',
        description: 'Reduce cost by 1pt.',
        type: [
            'M',
        ],
    },
    {
        id: 16,
        name: 'Gravlock',
        description: 'At the end of your move turn, you may set your Motion to 1. AUs can do this.',
        type: [
            'A',
        ],
    },
    {
        id: 17,
        name: 'Guardian',
        description: 'Lose 1 Rad and 1 Jolt in cooldown.',
        type: [
            'M',
        ],
    },
    {
        id: 18,
        name: 'Gyro',
        description: 'Move through rough and cover as open.',
        type: [
            'A',
        ],
    },
    {
        id: 19,
        name: 'Hooks',
        description: 'When a MAC you are touching moves, you may move with it.',
        type: [
            'I',
        ],
    },
    {
        id: 20,
        name: 'Hotstepper',
        description: 'When you jump and collide, cause an extra hit and 1 Heat to the target.',
        type: [
            'A',
        ],
    },
    {
        id: 21,
        name: 'Hoverfoil',
        description: 'Move through rough and water as open.',
        type: [
            'A',
        ],
    },
    {
        id: 22,
        name: 'Intake',
        description: 'Jumping generates 1 less Heat.',
        type: [
            'M',
        ],
    },
    {
        id: 23,
        name: 'Jet',
        description: 'Each jet allows up to 9" of jumping.',
        type: [
            'A',
        ],
    },
    {
        id: 24,
        name: 'Mesh',
        description: 'If the attack caused fewer than 3 hits, ignore hits to this module.',
        type: [
            'M',
        ],
    },
    {
        id: 25,
        name: 'Plate',
        description: 'Roll 4+ to ignore each hit to this module.',
        type: [
            'M',
        ],
    },
    {
        id: 26,
        name: 'Precog',
        description: 'When your initiative card is drawn, you may gain 1 Heat to shuffle it back into the deck instead of activating.',
        type: [
            'M',
        ],
    },
    {
        id: 27,
        name: 'Prism',
        description: 'At the end of your attack turn, lose 1 Heat for each ranged weapon you fired.',
        type: [
            'M',
        ],
    },
    {
        id: 28,
        name: 'Radiator',
        description: 'Lose 1 Heat in cooldown.',
        type: [
            'M',
        ],
    },
    {
        id: 29,
        name: 'Reflector',
        description: 'If the attack caused 3 or more hits, ignore hits to this module.',
        type: [
            'M',
        ],
    },
    {
        id: 30,
        name: 'Rotor',
        description: 'Rotate an extra time at any point of your move.',
        type: [
            'M',
        ],
    },
    {
        id: 31,
        name: 'Servo',
        description: 'Gain 1 less Heat for shifting or rushing.',
        type: [
            'M',
        ],
    },
    {
        id: 32,
        name: 'Shield',
        description: 'Gain 1 Heat to ignore each hit to this module.',
        type: [
            'M',
        ],
    },
    {
        id: 33,
        name: 'Tether',
        description: 'At the end of your move turn, you may cause 1 Jolt to a visible MAC within 3".',
        type: [
            'A',
        ],
    },
    {
        id: 34,
        name: 'Transport',
        description: 'This unit can rush.',
        type: [
            'I',
        ],
    },
    {
        id: 35,
        name: 'Vent',
        description: 'Lose 2 Heat when you hold in the move phase.',
        type: [
            'M',
        ],
    },
];
